import HTMLTitleController from './HTMLTitleController'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => {
  return {
    regionsData: state.REGIONS.regionsData,
    selectedRegionId: state.REGIONS.selectedRegionId,
    indicatorsData: state.INDICATORS.indicatorsData
  }
}

export default withRouter(connect(mapStateToProps)(HTMLTitleController))



// WEBPACK FOOTER //
// ./src/modules/Controllers/HTMLTitle/HTMLTitleController/index.js